
store.form = {};
store.form.autoChangeTimeout = null;
store.form.ajaxLastRequest = null;
store.form.autoChange = function($form, formClass) {
	$form.find('input[type=submit]').hide();
	$form.find(':input').change(function(){
		var changedName = this.name;
		var changedTo = $(this).val();
		var checked = (this.type === 'checkbox' || this.type === 'radio') ? this.checked : true;
		var isMultiple = ($form.find('[name='+changedName+']').length > 1);
		var formName = $form.parent().attr('id');
		$('form.'+formClass).each(function(){
			var $t = $(this);
			var n = $t.parent().attr('id');
			if (n != formName) {
				var $es = $t.find('[name='+changedName+']');
				if (isMultiple) {
					$es = $es.filter('[value='+changedTo+']');
				}
				if (checked && $es.length < 1) {
					var $h = $('<input type="hidden" name="'+changedName+'" />');
					$h.appendTo($t);
					$es = $h;
				}
				if (checked) {
					$es.val(changedTo);
				}
				else {
					$es.remove();
				}
			}
		});

		clearTimeout(store.form.autoChangeTimeout);
		if (store.form.ajaxLastRequest) {
			store.form.ajaxLastRequest.abort();
		}
		store.form.autoChangeTimeout = setTimeout(function(){
			$(document.body).addClass('waiting');
			$form.trigger('submit');
		}, 300);
	});
};
store.form.ajax = function($form, dests, callback) {
	$form.submit(function(){
		var opts = store.form.getOpts($form);
		jQuery.extend(opts, {
			success: function(content) {
				store.form.ajaxLastRequest = null;
				var isSuccess = false;
				if (content.length > 0) {
					isSuccess = true;
					var toUrl = this.url;
					if (toUrl.indexOf('?') === -1) {
						toUrl += '?';
					}
					history.replaceState({}, null, toUrl);
					store.$().find('.paginationControl a').each(function(){
						var newUrl = toUrl.replace(/&?page=[0-9]+&?/, '') + '&page=$1';
						//noinspection JSPotentiallyInvalidUsageOfThis
						this.href = this.href.replace(/.*page=([0-9]+).*/, newUrl);
					});
					if (typeof dests === 'string') {
						dests = {'': dests};
					}
					var $tmp = $('<div/>').html(content);
					for (var key in dests) {
						if (!dests.hasOwnProperty(key)) {
							continue;
						}
						var dest = dests[key];
						var $d = $(dest);
						var $content;
						if (key === '') {
							$content = $(content);
						}
						else {
							$content = $tmp.find(key);
						}
						if ($content.length > 0) {
							$d.replaceWith($content);
							store.responsiveImg($content);
						}
						else {
							isSuccess = false;
						}
					}
				}
				$(document.body).removeClass('waiting');
				if (isSuccess && typeof callback === 'function') {
					callback();
				}
			}
		});
		store.form.ajaxLastRequest = $.ajax(opts);
		return false;
	});
};
store.form.getOpts = function($form) {
	return {
		url: $form.get(0).action.replace(/\?.*/, ''),
		data: $form.formSerialize().replace(/[a-z0-9-]+=(&|$)/g,'').replace(/&$/, ''),
		type: "GET",
		dataType: "html"
	};
};
